// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconLogoutPath = 'M9.37.323A1 1 0 0 1 10.526.25l.104.074 3.7 3-1.26 1.554L11 3.197V9H9V3.197l-2.07 1.68-1.26-1.554 3.7-3ZM18 12a7.796 7.796 0 0 0-3.441-6.53L13.44 7.13l.207.145A5.8 5.8 0 0 1 16 11.991 6 6 0 1 1 4 12a5.804 5.804 0 0 1 2.559-4.87L5.44 5.47l-.23.161a7.8 7.8 0 0 0-3.21 6.378C2 16.419 5.58 20 10 20a8 8 0 0 0 8-8Z';
var IconLogout = baseIcon('IconLogout', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconLogoutPath
});
export default IconLogout;
//# sourceMappingURL=index.js.map